// PS 由于不同模块是不同后端写的，所以同一数据，不同后端字段可能不一样（广告等等），只能分开写枚举数组
// 全店铺运营 - 综合分析
export const settingList = [
  {id: 1, text: "销售",children: [
      {id: 'unitsOrdered', text: "销量",key: 'unitsOrdered'},
      {id: 'unitsOrderedB2b', text: "销量-B2B",key: 'unitsOrderedB2b'},
      {id: 'orderProductSales', text: "销售额",key: 'orderProductSales'},
      {id: 'orderProductSalesB2b', text: "销售额-B2B",key: 'orderProductSalesB2b'},
      {id: 'orders', text: "订单量",key: 'orders'},
      {id: 'refunds', text: "退款量",key: 'refunds'},
      {id: 'refundsRate', text: "退款率",key: 'refundsRate'},
      {id: 'returnProductSales', text: "退款销售额",key: 'returnProductSales'},
      {id: 'returns', text: "退货量",key: 'returns'},
      {id: 'returnsRate', text: "退货率",key: 'returnsRate'},
      {id: 'avgOrderItems', text: "平均订单商品种类数",key: 'avgOrderItems'},
      {id: 'avgUnitsOrderedSales', text: "平均订单价格",key: 'avgUnitsOrderedSales'},
    ]
  },
  {
    id:2,text:'流量',children:[
      {id:'sessionsMobile',text:'Sessions-移动端',key:'sessionsMobile'},
      {id:'sessionsBrowser',text:'Sessions-PC端',key:'sessionsBrowser'},
      {id:'sessions',text:'Sessions-总计',key:'sessions'},
      {id:'unitSessionPercentage',text:'CVR',key:'unitSessionPercentage'},
      {id:'pageViewsMobile',text:'PV-移动端',key:'pageViewsMobile'},
      {id:'pageViewsBrowser',text:'PV-PC端',key:'pageViewsBrowser'},
      {id:'pageViews',text:'PV-总计',key:'pageViews'},
      {id:'buyBoxPercentage',text:'Buybox',key:'buyBoxPercentage'},
    ]
  },
  {
    id:3,text:'排名',children:[
      {id:'mainCategoryRank',text:'大类排名',key:'mainCategoryRank'},
      {id:'subCategoryRank',text:'小类排名',key:'subCategoryRank'},
    ]
  },
  {id: 4, text: "广告",children: [
      {id: 'adsImpressions', text: "曝光量",key: 'adsImpressions', keyList: ["impressions"]},
      {id: 'adsClicks', text: "点击量",key: 'adsClicks', keyList: ["clicks"]},
      {id: 'ctr', text: "CTR",key: 'ctr'},
      {id: 'adsSpend', text: "广告花费",key: 'adsSpend', keyList: ["cost"]},
      {id: 'cpc', text: "CPC",key: 'cpc'},
      {id: 'adsOrders', text: "广告订单量",key: 'adsOrders'},
      {id: 'cr', text: "广告CVR",key: 'cr', keyList: ["cvr"]},
      {id: 'adsSales', text: "广告销售额",key: 'adsSales'},
      {id: 'acoS', text: "ACOS",key: 'acoS', keyList: ["acos"]},
      {id: 'acoAS', text: "ACOAS",key: 'acoAS', keyList: ["acoas"]},
      {id: 'asoAS', text: "ASOAS",key: 'asoAS', keyList: ["asoas"]},
      {id: 'roAS', text: "ROAS",key: 'roAS', keyList: ["roas"]},
    ]
  },
  {id: 5, text: "费用利润",children: [
      {id: 'totalIncome', text: "总收入",key: 'totalIncome'},
      {id: 'totalExpenditure', text: "总支出",key: 'totalExpenditure'},
      {id: 'salesGrossProfit', text: "销售毛利",key: 'salesGrossProfit'},
      {id: 'grossProfitRate', text: "销售毛利率",key: 'grossProfitRate'},
      {id: 'salesNetProfit', text: "销售净毛利",key: 'salesNetProfit'},
      {id: 'salesNetProfitRate', text: "销售净毛利率",key: 'salesNetProfitRate'},
    ]
  },
  {id: 6, text: "买家评论",children: [
      {id: "midBadReview", text: "Review中差评",key: 'midBadReview'},
      {id: "midBadFeedback", text: "Feedback中差评",key: 'midBadFeedback'},
      {id:'star',text:'评分',key:'star'}
    ]
  },
  {id: 7, text: "库存(商品维度)",children: [
    {id: 'fulfillableQuantity', text: "FBA可售",key: 'fulfillableQuantity'},
    {id: 'fulfillableAmount', text: "FBA可售货值",key: 'fulfillableAmount'},
    {id: 'saleableTurnover', text: "FBA可售周转",key: 'saleableTurnover'}
  ]
},
];

// 全店铺运营 - 广告分析
export const settingListAds = [
  {id: 1, text: "广告",children: [
      {id: 214, text: "曝光量",key: 'impressions'},
      {id: 215, text: "点击量",key: 'clicks'},
      {id: 216, text: "CTR",key: 'ctr'},
      {id: 217, text: "广告订单量",key: 'adsOrders'},
      {id: 218, text: "广告销售额",key: 'adsSales'},
      {id: 219, text: "广告CVR",key: 'cvr'},
      {id: 220, text: "广告花费",key: 'cost'},
      {id: 221, text: "CPC",key: 'cpc'},
      {id: 222, text: "ACOS",key: 'acos'},
      {id: 223, text: "ROAS",key: 'roas'},
      {id: 224, text: "ASOAS",key: 'asoas'},
      {id: 225, text: "ACOAS",key: 'acoas'},
    ]
  },
]

/**
 * 全店分析枚举对象，后端返回的值做映射
 * PS 不同后端接口得映射不一样，只能暂时做冗余
 * todo 后期看有什么办法处理
 */
export const settingMap = {
  // 综合分析
  unitsOrdered: "销量",
  unitsOrderedB2b: "销量-B2B",
  orderProductSales: "销售额",
  orderProductSalesB2b: "销售额-B2B",
  orders: "订单量",
  refunds: "退款量",
  refundsRate: "退款率",
  returnProductSales: "退款销售额",
  returns: "退货量",
  returnsRate: "退货率",
  avgOrderItems: "平均订单商品种类数",
  avgUnitsOrderedSales: "客单价",
  sessionsMobile:'Sessions-移动端',
  sessionsBrowser:'Sessions-PC端',
  sessions:'Sessions-总计',
  unitSessionPercentage:'CVR',
  pageViewsMobile:'PV-移动端',
  pageViewsBrowser:'PV-PC端',
  pageViews:'PV-总计',
  buyBoxPercentage:'Buybox',

  adsImpressions: "曝光量",
  adsClicks: "点击量",
  ctr: "CTR",
  adsOrders: "广告订单量",
  adsSales: "广告销售额",
  cr: "广告CVR",
  adsSpend: "广告花费",
  cpc: "CPC",
  acoS: "ACOS",
  roAS: "ROAS",
  asoAS: "ASOAS",
  acoAS: "ACOAS",
  midBadReview:'Review中差评',
  midBadFeedback:'Feedback中差评',

  totalIncome: "总收入",
  totalExpenditure: "总支出",
  salesGrossProfit: "销售毛利",
  grossProfitRate: "销售毛利率",
  salesNetProfit: "销售净毛利",
  salesNetProfitRate: "销售净毛利率",

  //广告分析冗余
  impressions: "曝光量",
  clicks: "点击量",
  cost: "广告总花费",
  roas: "ROAS",
  cvr: "广告CVR",
  acos: "ACOS",
  asoas: "ASOAS",
  acoas: "ACOAS"
  //广告分析-店铺按类型统计

}

//费用利润枚举
export const settingMapFeeDetails = {
  ["Sales"]: "销售额",
  ["Platform cost"]: "平台费",
  ["Shipping price"]: "运费",
  ["Returns cost"]: "退货补回成本",
  ["Ads sales"]: "广告销售额",
  ["Discount cost"]: "促销折扣",
  ["Purchase cost"]: "采购成本",
  ["Arrive cost"]: "到库成本",
  ["Shipping cost"]: "FBA配送费",
  ["Commission cost"]: "销售佣金",
  ["Refund cost"]: "退款",
  ["Ads spend"]: "广告花费",
  ["Multichannel deduction cost"]: "多渠道扣费",
  ["Bogus cost"]: "推广订单费用",
  ["Other"]: "其它",
  ["Storage cost"]: "仓储费",
}

export const oppositeList = ["refunds","refundsRate","returnProductSales","returns","returnsRate","acos",
  "acoS","asoAS","asoas","acoAS","acoas"];


